import React, { useEffect, useRef, useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import CustomPopup from "../Popups/CustomPopup";
import useInbox from "hooks/useInbox.ts";
import { useUser } from "contexts/userContext/userContext";
import Button from "components/Elements/Button/Button";
import useOnClickOutside from "../../../../hooks/useOnClickOutside.js";
import { selectSearchParams } from "store/selectors/inboxSelectors.ts";
import { useAppSelector } from "store/hooks.ts";

const FormFilter = () => {
  const { getFormList, fetchFormList, setSelectedMail, setSearchParams } =
    useInbox();
  const searchParams = useAppSelector(selectSearchParams);
  const { getUserData } = useUser();
  const { getTextByKey } = useContent();
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedForms, setSelectedForms] = useState<string[]>(
    searchParams.sf || []
  );
  const ref = useRef(null);

  useEffect(() => {
    const userId = getUserData()?.UserId;
    if (userId) {
      fetchFormList();
    }
  }, [getUserData()?.UserId]);

  useEffect(() => {
    if (!showDropdown) {
      setSelectedForms(searchParams.sf || []);
    }
  }, [showDropdown]);

  useOnClickOutside(ref, () => setShowDropdown(false));

  const handleSelect = (formId: string) => {
    if (selectedForms.includes(formId)) {
      setSelectedForms((prev) => prev.filter((value) => value !== formId));
    } else {
      setSelectedForms((prev) => [...prev, formId]);
    }
  };

  const handleApply = () => {
    setSelectedMail(null);

    setSearchParams({ sf: selectedForms });
    setShowDropdown(false);
  };

  const handleClearAll = () => {
    setSelectedMail(null);

    setSearchParams({ sf: [] });
    setShowDropdown(false);
  };

  const toggleShowDropdown = () => setShowDropdown((prev) => !prev);

  const handleCLose = () => {
    setShowDropdown(false);
  };

  return (
    <div className="filter-status-wrapper" ref={ref}>
      <div
        className={`filter-status-button ${
          selectedForms?.length ? "blue-border" : ""
        }`}
        onClick={toggleShowDropdown}
      >
        {(!!selectedForms?.length || !!selectedForms?.length) && (
          <div className="counter">{selectedForms?.length}</div>
        )}
        <Icon name="newInbox/form" large darkGray showTitle />
        <span>{getTextByKey("filter-form")}</span>
      </div>
      <CustomPopup showState={showDropdown} topPosition={50}>
        <div className="checkbox-list-dropdown">
          <Icon
            name="x"
            large
            gray
            onClick={handleCLose}
            iconClass="close-icon"
            showTitle
          />
          <h1>{getTextByKey("filter-form")}</h1>
          <hr />
          <ul>
            {Object.keys(getFormList())?.map((formId) => (
              <li key={formId} onClick={() => handleSelect(formId)}>
                <div
                  className={`checkbox-wrapper ${
                    selectedForms.includes(formId) ? "selected" : ""
                  }`}
                >
                  {selectedForms.includes(formId) && (
                    <Icon
                      name="newInbox/mark"
                      iconClass="mark-icon"
                      blue
                      showTitle={false}
                    />
                  )}
                </div>
                {getFormList()?.[formId]} (ID: {formId})
              </li>
            ))}
          </ul>
          <div className="buttons">
            <Button onClick={handleApply}>
              {getTextByKey("filter-apply")}
            </Button>
            <button className="clear-button" onClick={handleClearAll}>
              {getTextByKey("filter-clear-all")}
            </button>
          </div>
        </div>
      </CustomPopup>
    </div>
  );
};

export default FormFilter;
